module.exports = __webpack_public_path__ + "img/BeYou-Health-Bar-Design-Tashii-Designs-logo.625b37d7.jpg";